import { buildBoardDrawingGuideLines } from "../board-drawing-guide";
import type { AgentSkill } from "./types";

export const boardDrawingSkill: AgentSkill = {
	name: "board-drawing",
	description:
		"Diagram, illustration, chart, and layout rules for the live whiteboard. Use before drawing, sketching, spacing boxes, or fixing a diagram. Skip unless the user means the board or canvas.",
	body: buildBoardDrawingGuideLines().join("\n"),
	surface: "board",
};
